import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/arrow-right-black.svg';

const _withScopeId = n => (_pushScopeId("data-v-c8fc3a90"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["href"];
const _hoisted_2 = {
  class: "me-2 font-h6 fs-lg"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));

export default {
  __name: 'ButtonLink',
  props: {
    href: {
      type: String,
      required: true
    }
  },

  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("a", {
        class: "btn-web-link cursor rounded-pill text-black bg-white lh-base center",
        href: __props.href
      }, [_createElementVNode("span", _hoisted_2, [_renderSlot(_ctx.$slots, "default")]), _hoisted_3], 8, _hoisted_1);
    };
  }

};